export default function validateRoleDescription(text) {
  if (!text || text.trim().length < 15) {
    return { valid: false, reason: "too short" };
  }

  if (text.length > 300) {
    return { valid: false, reason: "too long" };
  }

  return { valid: true };
}
